interface RankChipProps {
  // The datatable serializes an unranked team as "" (not null), so accept the
  // string shape too and normalize below rather than trusting `!= null`.
  rank: number | string | null | undefined
}

/**
 * Compact "#N" ranking badge for inline use next to team names (scoreboard,
 * lists). Renders nothing unless the team has a real (positive) rank — an
 * unranked team arrives as null, undefined, "", or 0 and must show no badge.
 */
export function RankChip({ rank }: RankChipProps) {
  const n = typeof rank === 'number' ? rank : Number(rank)
  if (!Number.isFinite(n) || n < 1) return null

  return (
    <span
      className="shrink-0 inline-flex items-center rounded-md bg-accent/15 px-1.5 py-0.5 text-[11px] font-bold text-accent"
      style={{ fontVariantNumeric: 'tabular-nums' }}
    >
      #{n}
    </span>
  )
}
